import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The Nutritionist’s Vault™ (6 Volumes, 120+ pages)',
  price: '$19'
}, {
  label: '🎁 Bonus #1: The Professional Nutritionist’s Workbook',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: The Clinical Measurement & Tracker Kit',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: The 10-Minute Meal Plan Revolution',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: The Client Success Educational Handouts',
  price: 'FREE'
}, {
  label: '🎁 Bonus #5: The Private Practice Rapid Setup Checklist',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-192" data-mp="1td0h6rpvnfma">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-193" data-mp="1oefemln5kjuo">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-194" data-mp="1yept09kxbxbf">
          🚀 Start Managing Your Practice Confidently In 30 Days
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-195" data-mp="2c41ezcf9h549">
          Assess properly, plan efficiently and grow professionally. One single payment, lifetime
          access, everything ready to start today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-196" data-mp="2h4xsmhpf05mv">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-197" data-mp="rpzrew7immkq">
            <span data-id="element-198" data-mp="mshe6tmgtl6x">What's included</span>
            <span data-id="element-199" data-mp="2mt5uetuwu8t2">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-200" data-mp="2muqo6h9ehnpv">
              <span className="text-plum/80" data-id="element-201" data-mp="2ru3l5utzkb66">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-202" data-mp="2vt2qhgjmq9y5">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-203" data-mp="35qyza1p3gst3">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-204" data-mp="3aq36wnwdeihb">
              Real total value: <span className="text-plum/40 line-through" data-id="element-205" data-mp="3fid2okk62cri">$141</span>
            </span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "8px",
            paddingBottom: "11px"
          }} data-id="element-206" data-mp="3ji54mef21knw">
              <span className="relative inline-block font-display font-black leading-none" data-id="element-207" data-mp="3ogf24vo94xco">
                {/* Currency symbol — edit its size here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 pr-1.5 font-display font-black leading-none" style={{
                fontSize: "44px",
                fontFamily: "'Open Sans', sans-serif"
              }} data-id="element-208" data-mp="7h6ovtnixv7w">
                  $
                </span>
                {/* Amount — edit its size here */}
                <span className="text-grape-shine font-display font-black leading-none" style={{
                fontSize: "72px",
                fontFamily: "'Open Sans', sans-serif"
              }} data-id="element-209" data-mp="3pmtf13yftbqk">
                  19
                </span>
                {/* Currency code — edit its size here */}
                <span className="text-grape-shine absolute left-full top-1/2 -translate-y-1/2 pl-1.5 font-display font-black leading-none" style={{
                fontSize: "26px",
                fontFamily: "'Open Sans', sans-serif"
              }} data-id="element-210" data-mp="ggtpid8fiwzw">
                  USD
                </span>
              </span>
            </div>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-211" data-mp="146fr17c9xob2">
              One-time payment
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-212" data-mp="ond3f39jovut">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-213" data-mp="fo83bsic4ugj">
          <CTAButton data-id="element-214" data-mp="fpt07os4gphk">Get The Nutritionist’s Vault™</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-215" data-mp="jq3671fwzfwf">
          You save $122 USD (86% OFF) · One-time payment
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-216" data-mp="1cdzb2tfn0e4a">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-217" data-mp="ykhrx9qv53es">
              <Icon className="h-4 w-4 text-grape" data-id="element-218" data-mp="12mutrn2hoh6a" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}